"use client";

import CartIcon from "@/assets/svg/24/Cart";
import useCart from "@/lib/hooks/useCart";
import clsx from "clsx";
import { CartTriggerProps } from "./Cart";

export const CartTrigger = ({
  onClick,
  styles,
  activeStyles
}: CartTriggerProps) => {
  const { items } = useCart();
  const isCartActive = items.length > 0;

  return (
    <button
      className={clsx(styles, isCartActive && activeStyles)}
      onClick={onClick}
    >
      <CartIcon />
    </button>
  );
};
